import request from '@/utils/request';

export const queryWxjkOrder = (data) => {
  return request({
    url: "/api/core/wxjk/inner_query_order",
    method: "post",
    data,
  });
};

export const payWxjkOrder = (data) => {
  return request({
    url: "/api/core/wxjk/inner_deduct_order",
    method: "post",
    data
  })
}